import React, { PropTypes } from 'react'
import ContentContainer from '../ContentContainer/ContentContainer'
import Paragraph from './Paragraph'
import _ from 'lodash'
import FlexBox from '../FlexBox/FlexBox';

const Container = ({ entity: { fieldLayout, fieldItems} }) => {
  let containerClass;
  const hasCardMerger = _.find(fieldItems, ((item) => (item.entity.entityBundle === 'card_merger')));

  if (fieldLayout && fieldLayout.includes('hide-for-large-up')) {
    containerClass = 'hide-for-large-up'
  } else if (fieldLayout && fieldLayout.includes('show-for-large-up')) {
    containerClass = 'show-for-large-up'
  }

  if (hasCardMerger) {
    return (
      <ContentContainer width="wide" className={containerClass}>
        <div className="flex-box">
          <div className="merged-card-wrapper column small-4">
            {fieldItems.map(({ entity }) => <Paragraph key={entity.entityId} entity={entity} />)}
          </div>
        </div>
      </ContentContainer>
    )
  }

  if (!fieldLayout) {
    return (
      <ContentContainer width="wide" className={containerClass}>
        <div className="flex-box">
          {fieldItems.map(({ entity }) => <Paragraph key={entity.entityId} entity={entity} />)}
        </div>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer width="wide" className={containerClass}>
      <FlexBox>
          {fieldItems.map(({ entity }, i) => {
            const layoutProps = {
            }
            switch (fieldLayout) {
              case "1_col":
                layoutProps.small = "4"
                break
              case "1_col hide-for-large-up":
                layoutProps.small = "4"
                layoutProps.extraClassName = "hide-for-large-up"
                break
                case "1_col show-for-large-up":
                  layoutProps.small = "4"
                  layoutProps.extraClassName = "show-for-large-up"
                break
              case "2_col_50_50":
                layoutProps.small = "4"
                layoutProps.medium = "2"
                break;
              case "2_col_66_33":
                layoutProps.small = "4"
                if (i % 2 === 0) {
                  layoutProps.medium = "2-3"
                } else {
                  layoutProps.medium = "1-3"
                }
                break
              case "2_col_33_66":
                layoutProps.small = "4"
                if (i % 2 > 0) {
                  layoutProps.medium = "1-3"
                } else {
                  layoutProps.medium = "2-3"
                }
                break
              case "3_col":
                layoutProps.small = "4"
                layoutProps.medium = "1-3"
                break
              default:
            }

            const type = _.join(_.filter([entity.entityBundle, entity.fieldBlockName]), '-');

            switch (type) {
              case "link_list":
              case "embed_block-popular":
              case "card":
                layoutProps.flex = true
                break
              default:
            }

            return <Paragraph key={entity.entityId} entity={entity} even={i % 2 > 0} {...layoutProps} />
          })}
      </FlexBox>
    </ContentContainer>
  )
}

// Container.propTypes = {
//   entity: PropTypes.shape({
//     fieldLayout: PropTypes.string,
//     fieldItems: PropTypes.array
//   })
// }

export default Container
